import { render, staticRenderFns } from "./ToolFpaPlStatement.vue?vue&type=template&id=9ca152d4&scoped=true"
import script from "./ToolFpaPlStatement.vue?vue&type=script&lang=js"
export * from "./ToolFpaPlStatement.vue?vue&type=script&lang=js"
import style0 from "./ToolFpaPlStatement.vue?vue&type=style&index=0&id=9ca152d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca152d4",
  null
  
)

export default component.exports